import React, { Component } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import classnames from 'classnames';

import * as analyticsActions from '../../actions/analytics';

import ArtistAvatar from '../common/ArtistAvatar';
import CapacitorRipple from '../capacitor/Ripple';
import styles from './ArtistCollectionElement.css';
import collectibleEntity, { collectibleEntityPropTypes } from '../../hoc/collectibleEntity';
import { ENTITY_TYPE_ARTIST } from '../../constants';
import CollectionButton from '../common/CollectionButton';

class ArtistCollectionElement extends Component {
  static propTypes = {
    analyticsTrack: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    showCollectionButtonOnHover: PropTypes.bool,
    ...collectibleEntityPropTypes,
  };

  onItemClick = () => {
    const { id } = this.props;
    this.props.analyticsTrack('Selected Artist From Collection', { id });
  };

  render() {
    const { id, name, isInCollection, toggleIsInCollection, showCollectionButtonOnHover } =
      this.props;
    return (
      <div className={styles.component}>
        <ArtistAvatar className={styles.avatar} profileId={id} />
        <div className={styles.nameContainer}>
          <span className={styles.name} data-test="artist-collection-element.name">
            {name}
          </span>
          <CollectionButton
            active={isInCollection}
            onClick={toggleIsInCollection}
            className={classnames(styles.collectionButton, {
              [styles.collectionButtonOnHover]: showCollectionButtonOnHover,
            })}
          />
        </div>
        <Link
          to={`/profiles/${id}`}
          className={`${styles.profileLink} c-link--expand-hitbox`}
          onClick={this.onItemClick}
          data-test="artist-collection-element.link"
          aria-label={name}
        >
          <CapacitorRipple />
        </Link>
      </div>
    );
  }
}

function getCollectibleEntityDescription(props) {
  return {
    id: props.id,
    trackingSource: 'Profile',
  };
}

export default compose(
  connect(null, { analyticsTrack: analyticsActions.track }),
  collectibleEntity(ENTITY_TYPE_ARTIST, getCollectibleEntityDescription)
)(ArtistCollectionElement);
